import { AnalyticsService } from '@alison/analytics/client';
import Stack from '@mui/material/Stack';
import type { ReactNode } from 'react';
import type { CreativeDetailTab } from '../../../lib/creative-detail-search.js';
import type { DetailCreative } from '../data/api.js';
import { CreativeDetailFooter } from './CreativeDetailFooter.js';
import { CreativeDetailHeader } from './CreativeDetailHeader.js';
import { CreativeDetailTabs } from './CreativeDetailTabs.js';
import type { CreativeDetailScope } from './data/api.js';

interface CreativeDetailViewProps {
  creatives: DetailCreative[];
  creative: DetailCreative;
  tab: CreativeDetailTab;
  scope: CreativeDetailScope;
  kpis: string[];
  leadingKpiLabel: string;
  contextLabel?: string;
  onOpen: (creativeId: string) => void;
  onTabChange: (tab: CreativeDetailTab) => void;
  onClose: () => void;
}

export function CreativeDetailView({
  creatives,
  creative,
  tab,
  scope,
  kpis,
  leadingKpiLabel,
  contextLabel,
  onOpen,
  onTabChange,
  onClose,
}: CreativeDetailViewProps): ReactNode {
  const at = creatives.findIndex((entry) => entry.creativeId === creative.creativeId);

  const step = (direction: 'previous' | 'next'): void => {
    const target = creatives[direction === 'previous' ? at - 1 : at + 1];
    if (target === undefined) return;
    AnalyticsService.track('Creative Detail - Navigate', { direction });
    onOpen(target.creativeId);
  };

  return (
    <Stack sx={{ height: '100%', bgcolor: 'background.paper' }}>
      <CreativeDetailHeader
        creative={creative}
        position={at + 1}
        total={creatives.length}
        onPrevious={() => step('previous')}
        onNext={() => step('next')}
        onClose={onClose}
        {...(contextLabel !== undefined ? { contextLabel } : {})}
      />
      <CreativeDetailTabs
        tab={tab}
        onTabChange={onTabChange}
        scope={scope}
        creative={creative}
        kpis={kpis}
        leadingKpiLabel={leadingKpiLabel}
      />
      <CreativeDetailFooter />
    </Stack>
  );
}
